import React from "react";
import Navbar from "../Components/Navbar";
import Hero from "../Components/Hero";
import travel2 from "../assets/travel5.jpg";
import Trip from "../Components/Trip";
import Footer from "../Components/Footer";

const Service = () => {
  return (
    <div>
      <Navbar />
      <Hero
        cName="hero-middle"
        heroImg={travel2}
        title="Service"
        btnClass="hide"
      />
      <Trip />
      <Footer />
    </div>
  );
};

export default Service;
